import React, { useEffect, useState, useRef } from "react";
import { Grid, Box, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, IconButton, TableHead } from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
// styles
import useStyles from "../../../../themes/makeStyles";
import clsx from "clsx";
import moment from "moment";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PropTypes from "prop-types";
// import { default as Apiservices } from '../../../common'

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
    table: {
        minWidth: "100%",
        whiteSpace: "",
        td: {

        }
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        // maxHeight: "60vh",
        minHeight: "100px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        padding: 8
    },
    body: {
        fontSize: 14,
        padding: 8
    },
}))(TableCell);

export default function Table1(props) {
    var classesTwo = useStyles();
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);
    const [loading, setLoading] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    useEffect(() => {
    }, []);
    // console.log('props.item-->>', props.item)

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // const generateReport = async (details) => {
    //     console.log(details);
    //     let dates = {
    //         start_date: startDate,
    //         end_date: endDate
    //     }
    //     let filename =
    //         "consolidated_reports_" + moment(Date.now()).format("DD-MM-YYYY") + ".xlsx";
    //     let submitResults = await download_consolidated_reports(filename, dates);
    //     console.log(submitResults);
    //     // Apiservices.downloadDashboardJobDetails(startDate, endDate);
    // }

    return (
        <>
            <div>
                {/* <Box py={3}>
                    <Grid container spacing={2} justify="space-between" alignItems="center">
                        <Grid item>
                            <h2 className={classesTwo.mainHeading}>{"Tonnage Report"}</h2>
                        </Grid>
                    </Grid>
                </Box> */}

                <div>
                    <Box py={1}>
                        <TableContainer component={Paper} className={classes.container}>
                            <Table
                                className={classes.table}
                                aria-label="simple table"
                                stickyHeader
                            >
                                {loading ? (
                                    <h1>Skeleton comes here!</h1>
                                ) : (
                                    <>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center" colSpan={12}>
                                                    <b>SFTO</b>
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="">
                                                    <b>PARAMETERS</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>CUMM NTKM (MN)</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b> NTKM (MN) ON DATE</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>MONTHLY REV (CUMM) IN CR.</b>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <b>REV (AS ON DT) IN CR</b>
                                                </StyledTableCell>
                                                {/* <StyledTableCell align="center">
                                                    <b>REMARKS</b>
                                                </StyledTableCell> */}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {/* {(rowsPerPage > 0
                                                ? array.slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                : array
                                            ).map((row, index) => (
                                                
                                            ))} */}
                                            <TableRow>
                                                <TableCell align="">
                                                    <div>
                                                        <b>Target as per projection(Board Numbers)</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_target_as_per_project_cumm_ntkm ?
                                                                <b>{Number(props.item.sfto_target_as_per_project_cumm_ntkm).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center" >
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_target_as_per_project_ntkm_on_date ?
                                                                <b>{Number(props.item.sfto_target_as_per_project_ntkm_on_date).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_target_as_per_project_monthly_rev ?
                                                                <b>{Number(props.item.sfto_target_as_per_project_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center" >
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_target_as_per_project_rev ?
                                                                <b>{Number(props.item.sfto_target_as_per_project_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                {/* <TableCell align="center">
                                                    <div>
                                                        <b>-</b>
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="">
                                                    <div>
                                                        <b>Cumm Target</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_target_cumm_ntkm ?
                                                                <b>{Number(props.item.sfto_cumm_target_cumm_ntkm).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_target_ntkm_on_date ?
                                                                <b>{Number(props.item.sfto_cumm_target_ntkm_on_date).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_target_monthly_rev ?
                                                                <b>{Number(props.item.sfto_cumm_target_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_target_rev ?
                                                                <b>{Number(props.item.sfto_cumm_target_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                {/* <TableCell align="center" rowSpan={5}>
                                                    <div>
                                                        <b>-</b>
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="">
                                                    <div>
                                                        <b>Target Gap</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_target_to_be_achived_cumm_ntkm ?
                                                                <b>{Number(props.item.sfto_target_to_be_achived_cumm_ntkm).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center" >
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_target_to_be_achived_ntkm_on_date ?
                                                                <b>{Number(props.item.sfto_target_to_be_achived_ntkm_on_date).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_target_to_be_achived_monthly_rev ?
                                                                <b>{Number(props.item.sfto_target_to_be_achived_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center" >
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_target_to_be_achived_monthly_rev ?
                                                                <b>{Number(props.item.sfto_target_to_be_achived_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="">
                                                    <div>
                                                        <b>Cumm Actual</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_actual_cumm_ntkm ?
                                                                <b>{Number(props.item.sfto_cumm_actual_cumm_ntkm).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_actual_ntkm_on_date ?
                                                                <b>{Number(props.item.sfto_cumm_actual_ntkm_on_date).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_actual_monthly_rev ?
                                                                <b>{Number(props.item.sfto_cumm_actual_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_cumm_actual_rev ?
                                                                <b>{Number(props.item.sfto_cumm_actual_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                {/* <TableCell align="center">
                                                    <div>
                                                        <b></b>
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="">
                                                    <div>
                                                        <b>On Wheels</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_on_wheels_cumm_ntkm ?
                                                                <b>{Number(props.item.sfto_on_wheels_cumm_ntkm).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_on_wheels_ntkm_on_date ?
                                                                <b>{Number(props.item.sfto_on_wheels_ntkm_on_date).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_on_wheels_monthly_rev ?
                                                                <b>{Number(props.item.sfto_on_wheels_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_on_wheels_rev ?
                                                                <b>{Number(props.item.sfto_on_wheels_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                {/* <TableCell align="center">
                                                    <div>
                                                        <b></b>
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="">
                                                    <div>
                                                        <b>Running Avg</b>
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_running_average_cumm_ntkm ?
                                                                <b>{Number(props.item.sfto_running_average_cumm_ntkm).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center" >
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_running_average_ntkm_on_date ?
                                                                <b>{Number(props.item.sfto_running_average_ntkm_on_date).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div>
                                                        {
                                                            props.item.sfto_running_average_monthly_rev ?
                                                                <b>{Number(props.item.sfto_running_average_monthly_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <div style={{ visibility: 'hidden' }}>
                                                        {
                                                            props.item.sfto_running_average_rev ?
                                                                <b>{Number(props.item.sfto_running_average_rev).toFixed(2)}</b> :
                                                                <b>-</b>
                                                        }
                                                    </div>
                                                </TableCell>
                                                {/* <TableCell align="center">
                                                    <div>
                                                        <b></b>
                                                    </div>
                                                </TableCell> */}
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {/* <TableContainer>
                            <TablePagination
                                className={classes.toobarBgColor}
                                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                component="div"
                                count={array.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { "aria-label": "rows per page" },
                                    native: true,
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableContainer> */}
                    </Box>
                </div >
            </div>
        </>
    );
}